"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var AppLocale_1 = require("../../../../../shared/locale/AppLocale");
var RangePicker = antd_1.DatePicker.RangePicker;
var moment = require("moment");
var RangeSelectCard = /** @class */ (function (_super) {
    __extends(RangeSelectCard, _super);
    function RangeSelectCard(props) {
        var _this = _super.call(this, props) || this;
        _this.range_day = "a";
        _this.range_today = "b";
        _this.range_week = "c";
        _this.range_month = "d";
        _this.range_select = "f";
        _this.dFormat = "YYYY-MM-DD HH:mm:ss";
        return _this;
    }
    RangeSelectCard.prototype.componentWillMount = function () {
        /* this.setState({
             from: moment('00:00:00', 'HH:mm:ss'),
             to: moment('11:59:59', 'HH:mm:ss'),
             disabled: true,
             selectedRadio: this.range_today
         })*/
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            });
        });
        this.setState({
            dtFrom: this.props.state.DATA.dtFrom,
            dtTo: this.props.state.DATA.dtTo,
            dtFormat: this.props.state.DATA.dtTimeFormat
        }, function () {
            _this.loadData();
        });
    };
    RangeSelectCard.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    RangeSelectCard.prototype.onSelectionChange = function (e) {
        if ((e.target.value) && (e.target.value === this.range_day)) {
            if (e.target.checked) {
                this.setState({
                    dtFrom: moment('00:00:00', 'HH:mm:ss').subtract(1, 'days'),
                    dtTo: moment('00:00:00', 'HH:mm:ss'),
                    disabled: true,
                    selectedRadio: this.range_day
                });
            }
        }
        if ((e.target.value) && (e.target.value === this.range_today)) {
            if (e.target.checked) {
                this.setState({
                    dtFrom: moment('00:00:00', 'HH:mm:ss'),
                    dtTo: moment('11:59:59', 'HH:mm:ss'),
                    disabled: true,
                    selectedRadio: this.range_today
                });
            }
        }
        if ((e.target.value) && (e.target.value === this.range_week)) {
            if (e.target.checked) {
                this.setState({
                    dtFrom: moment().subtract(7, 'days'),
                    dtTo: moment(),
                    disabled: true,
                    selectedRadio: this.range_week
                });
            }
        }
        if ((e.target.value) && (e.target.value === this.range_month)) {
            if (e.target.checked) {
                this.setState({
                    dtFrom: moment().subtract(1, 'month'),
                    dtTo: moment(),
                    disabled: true,
                    selectedRadio: this.range_month
                });
            }
        }
        if ((e.target.value) && (e.target.value === this.range_select)) {
            if (e.target.checked) {
                this.setState({
                    disabled: false,
                    selectedRadio: this.range_select
                });
            }
        }
    };
    RangeSelectCard.prototype.loadData = function () {
        var _this = this;
        this.props.data.LoadBrandsData({
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            from_second: this.state.dtFrom.get('second'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
            to_second: this.state.dtTo.get('second'),
        }, function () {
            _this.loadCommonData();
        });
    };
    RangeSelectCard.prototype.loadCommonData = function () {
        this.props.data.LoadCommonData({
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            from_second: this.state.dtFrom.get('second'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
            to_second: this.state.dtTo.get('second'),
        }, function () { });
    };
    //private getpDownMenu(): JSX.Element {
    //    return (
    //        <Menu onClick={(e) => { console.log(e.key) }}>
    //            <Menu.Item key={"2_k"} ><FA left icon="sync" />Обновить</Menu.Item>
    //        </Menu>
    //    )
    //}
    RangeSelectCard.prototype.onRangeChanged = function (dates, dateStrings) {
        this.setState({
            dtFrom: dates[0],
            dtTo: dates[1]
        });
    };
    RangeSelectCard.prototype.render = function () {
        var _this = this;
        var _w = 120;
        return (React.createElement(antd_1.Card, { bordered: false, title: "Период просмотра", 
            /*extra={
                <Dropdown overlay={this.getpDownMenu()} trigger={['click']}>
                    <a href="#">Дополнительно<FA right icon="angle-down" /></a>
                </Dropdown>
            }*/
            style: { width: "100%", height: "100%" } },
            React.createElement("div", { style: { height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-start", flexDirection: "column" } },
                React.createElement(antd_1.Radio.Group, { value: this.state.selectedRadio, buttonStyle: "outline", onChange: this.onSelectionChange.bind(this) },
                    React.createElement(antd_1.Radio.Button, { style: { width: _w + "px", textAlign: "center" }, value: this.range_day },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "check" }),
                        "\u0412\u0447\u0435\u0440\u0430"),
                    React.createElement(antd_1.Radio.Button, { style: { width: _w + "px", textAlign: "center" }, value: this.range_today },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "check" }),
                        "\u0421\u0435\u0433\u043E\u0434\u043D\u044F"),
                    React.createElement(antd_1.Radio.Button, { style: { width: _w + "px", textAlign: "center" }, value: this.range_week },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "check" }),
                        "\u041D\u0435\u0434\u0435\u043B\u044F"),
                    React.createElement(antd_1.Radio.Button, { style: { width: _w + "px", textAlign: "center" }, value: this.range_month },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "check" }),
                        "\u041C\u0435\u0441\u044F\u0446"),
                    React.createElement(antd_1.Radio.Button, { style: { width: _w + "px", textAlign: "center" }, value: this.range_select },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "search" }),
                        "\u0412\u044B\u0431\u0440\u0430\u0442\u044C")),
                React.createElement("div", { style: { margin: 0, marginTop: 5, width: _w * 5 + "px" } },
                    React.createElement(antd_1.Input.Group, { compact: true },
                        React.createElement(RangePicker, { style: { width: 480 + "px" }, value: [
                                this.state.dtFrom,
                                this.state.dtTo
                            ], format: this.dFormat, locale: AppLocale_1.AppLocale.getRangeSelectLocale(), onChange: this.onRangeChanged.bind(this), showTime: true, disabled: this.state.disabled }),
                        React.createElement(antd_1.Button, { style: { width: 120 }, icon: "sync", onClick: function () { _this.loadData(); } }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"))))));
    };
    return RangeSelectCard;
}(React.Component));
exports.default = RangeSelectCard;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_dashboard/ui/component/RangeSelectCard.tsx
// module id = 1746
// module chunks = 0